import { withApiMutation } from "#src/stores/Api.tsx";
import { sendEmail, sendEmailVariables } from "#types/code-generator.ts";
import type { TypedDocumentNode } from "#types/graphql.d.ts";
import { gql } from "graphql-tag";

export const SendEmailMutation = gql`
  mutation sendEmail($data: SendEmailInput!) {
    sendEmail(data: $data) {
      success
    }
  }
` as TypedDocumentNode<sendEmail, sendEmailVariables>;

export const SendEmail = withApiMutation(SendEmailMutation, {
  name: "sendEmail",
});
